import api from './api';

export interface Product {
  id: string;
  category: 'Mobility' | '5G' | 'Fixed_BBI' | 'Fixed_BDI';
  name: string;
  description: string;
  price: number;
  vatRate: number;
  requiresCoverage: boolean;
  isBestseller: boolean;
  configSchema: Record<string, unknown> | null;
  isActive: boolean;
  sortOrder: number;
  setupFee?: number | null;
  cancellationFee?: number | null;
  installationTimeline?: string | null;
  contractTerms?: string | null;
}

export const productsService = {
  list: () => api.get<Product[]>('/products').then((r) => r.data),
  get: (id: string) => api.get<Product>(`/products/${id}`).then((r) => r.data),
};
